module.exports = __webpack_public_path__ + "img/list.png?865227ed9340eb06805eb1898d7ccd77";